// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invitation_wrapper__28p\\+R {
  display: grid;
  gap: 32px;
  padding: 48px;
  justify-content: center;
  align-items: center;
}

.invitation_logo-wrapper__3MeIV {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.invitation_content__mYo1w {
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
  max-width: 600px;
}

.invitation_description__AGeIF {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.invitation_header__K3iQK {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.invitation_title__Pw6H1 {
  font-size: 32px;
  font-weight: 800;
}

.invitation_team__AXWzb {
  color: var(--error-text-color);
}

.invitation_role__SJbZD {
  text-transform: capitalize;
  color: var(--start-actions-color);
}

.invitation_register__0aSJh {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.invitation_form__PPr9Z {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: min-content 1fr;
  gap: 24px;
  padding: 24px;
  background-color: var(--white-text-color);
}

.invitation_form-header__dezgN {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 24px;
  border-bottom: 1px solid var(--primary-border-color);
}

.invitation_form-content__xbw2R {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 24px;
}

.invitation_actions__-IjbC {
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 980px) {
  .invitation_wrapper__28p\\+R {
    padding: 24px;
  }

  .invitation_form-content__xbw2R {
    grid-template-columns: 1fr;
  }

  .invitation_title__Pw6H1 {
    font-size: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/register/invitation.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,mCAAmC;EACnC,SAAS;EACT,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;EACpB,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".wrapper {\n  display: grid;\n  gap: 32px;\n  padding: 48px;\n  justify-content: center;\n  align-items: center;\n}\n\n.logo-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n}\n\n.content {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 32px;\n  max-width: 600px;\n}\n\n.description {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.header {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.title {\n  font-size: 32px;\n  font-weight: 800;\n}\n\n.team {\n  color: var(--error-text-color);\n}\n\n.role {\n  text-transform: capitalize;\n  color: var(--start-actions-color);\n}\n\n.register {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.form {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: min-content 1fr;\n  gap: 24px;\n  padding: 24px;\n  background-color: var(--white-text-color);\n}\n\n.form-header {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-bottom: 24px;\n  border-bottom: 1px solid var(--primary-border-color);\n}\n\n.form-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: 1fr 1fr;\n  gap: 24px;\n}\n\n.actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n@media (max-width: 980px) {\n  .wrapper {\n    padding: 24px;\n  }\n\n  .form-content {\n    grid-template-columns: 1fr;\n  }\n\n  .title {\n    font-size: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `invitation_wrapper__28p+R`,
	"logo-wrapper": `invitation_logo-wrapper__3MeIV`,
	"content": `invitation_content__mYo1w`,
	"description": `invitation_description__AGeIF`,
	"header": `invitation_header__K3iQK`,
	"title": `invitation_title__Pw6H1`,
	"team": `invitation_team__AXWzb`,
	"role": `invitation_role__SJbZD`,
	"register": `invitation_register__0aSJh`,
	"form": `invitation_form__PPr9Z`,
	"form-header": `invitation_form-header__dezgN`,
	"form-content": `invitation_form-content__xbw2R`,
	"actions": `invitation_actions__-IjbC`
};
export default ___CSS_LOADER_EXPORT___;
